import {
  SizeTypeLabel,
  RoofTypeLabel,
  CabinTypeLabel,
  DrivetrainLabel,
  EngineTypeLabel,
} from '@/types';
import { getDefaultLocaleValue } from '../locales/default';
import {
  mapSizeTypeLabelToTranslation,
  mapRoofTypeLabelToTranslation,
  mapCabinTypeLabelToTranslation,
  mapDrivetrainTypeLabelToTranslation,
  mapEngineTypeLabelToTranslation,
} from '@/utils/translations';

export function useTranslations(translations: Record<string, string>) {
  const getTranslation = (key: string, fallbackKey: string) => {
    return translations[key] || getDefaultLocaleValue(fallbackKey);
  };

  return {
    getSizeTypeTranslation: (sizeType: SizeTypeLabel) =>
      getTranslation(
        mapSizeTypeLabelToTranslation(sizeType),
        `sizeType_${sizeType.toLowerCase()}`,
      ),
    getRoofTypeTranslation: (roofType: RoofTypeLabel) =>
      getTranslation(
        mapRoofTypeLabelToTranslation(roofType),
        `roofType_${roofType.toLowerCase()}`,
      ),
    getCabinTypeTranslation: (cabinType: CabinTypeLabel) =>
      getTranslation(
        mapCabinTypeLabelToTranslation(cabinType),
        `cabinType_${cabinType.toLowerCase()}`,
      ),
    getDrivetrainTranslation: (drivetrain: DrivetrainLabel) =>
      getTranslation(
        mapDrivetrainTypeLabelToTranslation(drivetrain),
        `drivetrain_${drivetrain.toLowerCase()}`,
      ),
    getEngineTypeTranslation: (engineType: EngineTypeLabel) =>
      getTranslation(
        mapEngineTypeLabelToTranslation(engineType),
        `engineType_${engineType.toLowerCase()}`,
      ),
    getComponentLabel: (key: string, fallbackKey: string) =>
      getTranslation(key, fallbackKey),
  };
}
